import { useSuspenseQuery } from '@tanstack/react-query'

import { GetAcessoriosDisponiveisService } from '@/features/simulador/brasil/http'
import { produtosKeys } from '@/utils/produtos-query-keys'

export const useSuspenseAcessoriosDisponiveis = (idExternoBloco: number, simulacaoId: string) => {
  return useSuspenseQuery({
    queryKey: produtosKeys.acessoriosDisponiveis(idExternoBloco, simulacaoId),
    queryFn: async () => new GetAcessoriosDisponiveisService().execute(idExternoBloco).then((res) => res.data),
    staleTime: Infinity,
  })
}
